/**
 * Builds a unique rowId to match services in the UI, since `service_id` can be
 * duplicated within a category. Uses `{id}-{sequenceId}` when the unique
 * `sequence_id` is present, otherwise the plain `id` (new services can't duplicate).
 */
export const buildServiceRowId = (id: string, sequenceId?: number | null): string =>
  sequenceId != null ? `${id}-${sequenceId}` : id;
